import React from 'react';
import {Card, CardBody, CardHeader, Row} from 'reactstrap';
import PropTypes from "prop-types";
import BaseComponent from "../BaseComponent";
import ReleaseVerificationFormCheckWidget from "./ReleaseVerificationFormCheckWidget";

export default class ReleaseVerificationFormLaneCheckWidget extends BaseComponent{

    constructor(props) {
        super(props);
        let state = this.state
        state.releaseVerification = this.props.releaseVerification
        state.formLaneApplication = this.props.formLaneApplication?this.props.formLaneApplication:{}
        state.stepFormLaneId = this.props.stepFormLaneId ;
        this.setState(state)
    }

    componentWillReceiveProps(props, nextContext) {
        if(props!=this.props){
            let state = this.state
            state.releaseVerification = props.releaseVerification
            state.formLaneApplication = props.formLaneApplication?props.formLaneApplication:{}
            state.stepFormLaneId = props.stepFormLaneId ;
            this.setState(state)
        }
    }

    render() {
        let {releaseVerification, formLaneApplication, stepFormLaneId} = this.state
        let formApplications = formLaneApplication.formApplications?formLaneApplication.formApplications:[]
        if(stepFormLaneId!==formLaneApplication.laneId){
            return null;
        }
        return (
            <>
                {super.render()}
                <Card>
                    <CardHeader>{formLaneApplication.title+" "+formLaneApplication.laneId}</CardHeader>
                    <CardBody>
                        <Row>
                            {
                                formApplications.map((value, index) => (
                                    <ReleaseVerificationFormCheckWidget
                                        releaseVerification={releaseVerification}
                                        stepFormLaneId={stepFormLaneId}
                                        formLaneApplication={formLaneApplication}
                                        formApplication={value}/>
                                ))
                            }
                        </Row>

                    </CardBody>
                </Card>
            </>
        );
    }
}

ReleaseVerificationFormLaneCheckWidget.propTypes = {
    releaseVerification:PropTypes.object.isRequired,
    stepFormLaneId:PropTypes.object.isRequired,
    formLaneApplication:PropTypes.object.isRequired,
}

